
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/datasource-guide",
      function () {
        return require("private-next-pages/guides/datasource-guide.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/datasource-guide"])
      });
    }
  